export default __webpack_public_path__ + "static/media/Group9253.c530eec4.svg";